import { ADD_EXPERIMENT, CLEAR_EXPERIMENT } from './const';

const DEFAULT_STATE = {
  name: undefined,
  parameters: undefined
};

/**
 * reducer for experiments
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
const reducer = function experimentReducer(state = DEFAULT_STATE, action = {}) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case ADD_EXPERIMENT:
      return {
        ...state,
        name: action.name,
        parameters: action.parameters
      };
    case CLEAR_EXPERIMENT:
      return {
        ...state,
        name: undefined,
        parameters: undefined
      };
    default:
      return state;
  }
};

export default reducer;
